const html = require('choo/html');

module.exports = function(state, emit) {
  return html`
    <main class="main">
      <section
        class="relative flex flex-col items-center justify-center h-full w-full p-6 md:p-8 md:rounded-xl md:shadow-big"
      >
        <h1 class="text-3xl font-bold mb-4">
          Authentication via sim
        </h1>
        <p
          class="w-full text-grey-80 text-center leading-normal dark:text-grey-40"
        >
          Use SIM-based authentication for secure access. Enter your Icelandic
          phone number to start the authentication.
        </p>
        ${state.fileInfo
          ? html`
              <div class="mt-6">
                <p>
                  ${JSON.stringify(state.fileInfo)}
                </p>
              </div>
            `
          : ''}
        ${state.taktikalResponse
          ? state.taktikalResponse == 403
            ? html`
                <div class="mt-6">
                  <p>User cancelled the authentication request.</p>
                </div>
              `
            : state.taktikalResponse == 200
            ? html`
                <div class="mt-6">
                  <p>Authentication successful.</p>
                </div>
              `
            : html`
                <div class="mt-6">
                  <p>${state.taktikalResponse}</p>
                </div>
              `
          : ''}
        <form
          class="flex flex-row flex-no-wrap mx-auto justify-center w-full mt-4 md:w-4/5 "
          onsubmit="${snnAuth}"
          data-no-csrf
        >
          <input
            type="tel"
            id="phone-input"
            class=" border-l border-t border-b rounded-l-lg rounded-r-none pl-4 w-auto text-black dark:text-white border-grey dark:border-grey-40"

            oninput="${phoneChanged}"
            value=""
            placeholder="4151337"
            maxlength="7"
          />
          <input
            type="submit"
            id="phone-btn"
            class="btn rounded-r-lg rounded-l-none"
            value=""
            title=""
          />
        </form>

        ${state.taktikalStart &&
        state.taktikalStart.verificationCode != undefined
          ? html`
              <div class="mt-6">
                <p>
                  Source verification code:
                  "${state.taktikalStart.verificationCode}"
                </p>
              </div>
            `
          : ''}
      </section>
    </main>
  `;

  function phoneChanged(event) {
    event.stopPropagation();
    event.preventDefault();
    state.syndisInputs.taktikalPhone = event.target.value;
  }

  function snnAuth(event) {
    event.stopPropagation();
    event.preventDefault();
    document.getElementById('phone-btn').disabled = true;

    const id = state.params.id;

    emit('taktikalAuth', {
      phone: state.syndisInputs.taktikalPhone,
      id: id
    });

    // For example, directly update state.taktikalStart here
    state.taktikalStart = 'Authentication in progress...';
    state.taktikalResponse = 'Sending request to user';
    emit('render'); // Rerender after updating state
  }
};
